module.exports = __webpack_public_path__ + "static/good_deals-ecf8e83509647911fe97b55c7ae2ab57.png";